import { MessageChannel } from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

export const MESSAGE_TEMPLATES_BASE_QUERY_KEY = 'message-templates';

export const messageTemplatesApiQueryKeys = {
  all: (channel: MessageChannel) =>
    [MESSAGE_TEMPLATES_BASE_QUERY_KEY, channel] as const,
  variables: (channel: MessageChannel, type: string) =>
    [MESSAGE_TEMPLATES_BASE_QUERY_KEY, 'variables', channel, type] as const,
};
